import { resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_icon = _resolveComponent("q-icon")!
  const _component_q_item_section = _resolveComponent("q-item-section")!
  const _component_q_item_label = _resolveComponent("q-item-label")!
  const _component_q_tooltip = _resolveComponent("q-tooltip")!
  const _component_q_item = _resolveComponent("q-item")!
  const _component_NavItem = _resolveComponent("NavItem", true)!
  const _component_q_list = _resolveComponent("q-list")!
  const _component_q_slide_transition = _resolveComponent("q-slide-transition")!

  return (_ctx.isLink(_ctx.item) && _ctx.isAuthorized(_ctx.item))
    ? (_openBlock(), _createBlock(_component_q_item, {
        key: 0,
        to: (_ctx.item as any).href,
        class: "text-grey-6 tw-sidebar-btn relative",
        clickable: ""
      }, {
        default: _withCtx(() => [
          (_ctx.item.icon)
            ? (_openBlock(), _createBlock(_component_q_item_section, {
                key: 0,
                avatar: ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_icon, {
                    name: _ctx.item.icon
                  }, null, 8, ["name"])
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          _createVNode(_component_q_item_section, null, {
            default: _withCtx(() => [
              _createVNode(_component_q_item_label, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.i18n.global.t(_ctx.item.label)), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          (_ctx.sidebarMini && _ctx.item.icon)
            ? (_openBlock(), _createBlock(_component_q_tooltip, {
                key: 1,
                anchor: "center right",
                self: "center left",
                offset: [8, 0],
                class: "tw-side-nav-tooltip"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.i18n.global.t(_ctx.item.label)), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["to"]))
    : (_ctx.isDropdown(_ctx.item) && _ctx.isAuthorized(_ctx.item))
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _createVNode(_component_q_item, {
            clickable: "",
            onClick: _ctx.toggle,
            class: "text-grey-6 tw-sidebar-btn"
          }, {
            default: _withCtx(() => [
              (_ctx.item.icon)
                ? (_openBlock(), _createBlock(_component_q_item_section, {
                    key: 0,
                    avatar: ""
                  }, {
                    default: _withCtx(() => [
                      _createVNode(_component_q_icon, {
                        name: _ctx.item.icon
                      }, null, 8, ["name"])
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true),
              _createVNode(_component_q_item_section, null, {
                default: _withCtx(() => [
                  _createVNode(_component_q_item_label, null, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.i18n.global.t(_ctx.item.label)), 1)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              }),
              _createVNode(_component_q_item_section, { side: "" }, {
                default: _withCtx(() => [
                  _createVNode(_component_q_icon, {
                    name: _ctx.open ? 'expand_less' : 'expand_more'
                  }, null, 8, ["name"])
                ]),
                _: 1
              }),
              (_ctx.sidebarMini && _ctx.item.icon)
                ? (_openBlock(), _createBlock(_component_q_tooltip, {
                    key: 1,
                    anchor: "center right",
                    self: "center left",
                    offset: [8, 0],
                    class: "tw-side-nav-tooltip"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.i18n.global.t(_ctx.item.label)), 1)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["onClick"]),
          _withDirectives(_createVNode(_component_q_slide_transition, null, {
            default: _withCtx(() => [
              _createVNode(_component_q_list, {
                dense: "",
                class: "tw-side-bar-mernu-expanded-items"
              }, {
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList((_ctx.item as any).items, (child, index) => {
                    return (_openBlock(), _createBlock(_component_NavItem, {
                      key: index,
                      item: child
                    }, null, 8, ["item"]))
                  }), 128))
                ]),
                _: 1
              })
            ]),
            _: 1
          }, 512), [
            [_vShow, _ctx.open]
          ])
        ], 64))
      : _createCommentVNode("", true)
}